// extracted by mini-css-extract-plugin
export var banner = "_gn-0";
export var closeButton = "_gn-2";
export var greenCheckmark = "_gn-3";
export var hereLink = "_gn-4";
export var titleIcon = "_gn-1";